import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { singleClickHoldsSettingsShape } from '@bibliocommons/bc-prop-types';

const accountShape = ImmutablePropTypes.contains({
  id: PropTypes.number.isRequired,
  libId: PropTypes.number,
  digitalNotificationEmail: PropTypes.string,
  expiryDate: PropTypes.string,
  importedILSShelves: PropTypes.bool,
  borrowingHistoryEnabled: PropTypes.bool,
  singleClickHoldsSettings: singleClickHoldsSettingsShape,
  preferredLocations: ImmutablePropTypes.listOf(PropTypes.string)
});

export default accountShape;
